// 导出一个函数，用于获取检查项
export const getInspectionItems = () => {
  // 从本地存储中获取所有检查项的列表
  let allList = localStorage.getItem('ALLINSPECTIONITEMS') || []
  if (allList && allList.length) {
    allList = JSON.parse(allList)
  }
  // 从本地存储中获取已选择的检查项的列表
  let list = localStorage.getItem('INSPECTIONITEMS') || []
  if (list && list.length) {
    list = JSON.parse(list)
  }
  // 返回一个对象，包含所有检查项的集合和已选择的检查项的集合
  return {
    allSelectedIds: new Set(allList),
    selectedIds: new Set(list)
  }
}

// 检查项目
// 导出一个函数，用于设置检查项
export const setInspectionItems = ({ allSelectedIds, selectedIds }) => {
  // 将所有选中的检查项存储到本地缓存中
  localStorage.setItem('ALLINSPECTIONITEMS', JSON.stringify([...allSelectedIds]))
  // 将选中的检查项存储到本地缓存中
  localStorage.setItem('INSPECTIONITEMS', JSON.stringify([...selectedIds]))
}

// 添加检查项目
export default {
  namespaced: true,
  state: {
    patient: null, // 受者信息
    // define your state
    allSelectedIds: new Set(), // 是否全选
    selectedIds: new Set(), // 是否选中
    ...getInspectionItems() // 获取缓存
  },
  mutations: {
    setPatient(state, data) {
      state.patient = data
    },
    // define your actions
    addAllSelectedIds(state, data) {
      state.allSelectedIds.add(data)
    },
    deleteAllSelectedIds(state, data) {
      state.allSelectedIds.delete(data)
    },
    clearAllSelectedIds(state) {
      state.allSelectedIds.clear()
    },
    addSelectedIds(state, data) {
      state.selectedIds.add(data)
    },
    deleteSelectedIds(state, data) {
      state.selectedIds.delete(data)
    },
    clearSelectedIds(state) {
      state.selectedIds.clear()
    }
  }
}
